/**
 * Czytelny komunikat z bledu walidacji API. `zValidator` bez wlasnego hooka
 * odsyla `{ success: false, error: { name: 'ZodError', issues: [...] } }` —
 * bez `error.message`, wiec uzytkownik widzial tylko „HTTP 400” (Dawid
 * 2026-09-30: „nie moge zapisac nowej oferty”, a chodzilo o pow. podlog > 10 000 m²).
 */

/** Klucze pol z API → nazwy z formularzy. */
const FIELD_LABELS: Record<string, string> = {
  areaUsableM2: 'Pow. użytkowa',
  areaFloorM2: 'Pow. podłóg',
  areaBuiltM2: 'Pow. zabudowy',
  basementAreaM2: 'Pow. piwnic',
  groundFloorAreaM2: 'Pow. parteru',
  upperFloorAreaM2: 'Pow. piętra',
  atticAreaM2: 'Pow. poddasza',
  mbFenceFront: 'Ogrodzenie frontowe',
  mbFenceSide: 'Ogrodzenie boczne',
  m2Plot: 'Działka',
  m2Paved: 'Tereny utwardzone',
  m2Terrace: 'Tarasy',
  quantity: 'Ilość',
  priceOverrideGrosze: 'Cena',
  discountPercent: 'Rabat',
  internalLabel: 'Nazwa wewnętrzna',
  name: 'Nazwa',
  phone: 'Telefon',
  email: 'E-mail',
  email2: 'E-mail dodatkowy',
  city: 'Miasto',
  region: 'Region',
  address: 'Adres',
  budgetRange: 'Budżet',
  plotAreaM2: 'Działka',
  houseAreaM2: 'Pow. domu',
};

interface IssueLike {
  code?: string;
  path?: Array<string | number>;
  type?: string;
  maximum?: number;
  minimum?: number;
  inclusive?: boolean;
}

export function describeValidationError(body: unknown): string | null {
  if (!body || typeof body !== 'object' || !('error' in body)) return null;
  const error = body.error;
  if (!error || typeof error !== 'object' || !('issues' in error)) return null;
  const issues = error.issues;
  if (!Array.isArray(issues) || issues.length === 0) return null;
  const parts = issues.slice(0, 3).map((issue: IssueLike) => describeIssue(issue));
  return `Popraw w formularzu: ${parts.join('; ')}`;
}

function describeIssue(issue: IssueLike): string {
  const key = [...(issue.path ?? [])].reverse().find((p) => typeof p === 'string') ?? '';
  const label = FIELD_LABELS[key] ?? key;
  const reason = describeReason(issue);
  return label ? `${label} — ${reason}` : reason;
}

function describeReason(issue: IssueLike): string {
  const unit = issue.type === 'string' ? ' znaków' : '';
  if (issue.code === 'too_big' && issue.maximum !== undefined) {
    return `maksymalnie ${issue.maximum.toLocaleString('pl-PL')}${unit}`;
  }
  if (issue.code === 'too_small' && issue.minimum !== undefined) {
    if (issue.minimum === 0 && issue.inclusive === false) return 'musi być większe od 0';
    return `minimum ${issue.minimum.toLocaleString('pl-PL')}${unit}`;
  }
  return 'nieprawidłowa wartość';
}
